/*
 * Copyright (c) 2026, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you've
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { azureInsightsKey } from 'config';

import { isStrictlyNecessaryCookiesAllowed } from './oneTrustCookiePro';

const reactPlugin = new ReactPlugin();
const ai = new ApplicationInsights({
  config: {
    instrumentationKey: azureInsightsKey,
    extensions: [reactPlugin],
  },
});
if (azureInsightsKey) {
  ai.loadAppInsights();
}

export function publishToAppInsights(
  name: string,
  properties: Record<string, any>
) {
  if (!azureInsightsKey) return;

  const isAppInsightAllowed = isStrictlyNecessaryCookiesAllowed();
  if (!isAppInsightAllowed) return;

  const { appInsights } = ai;
  appInsights.trackEvent({ name }, properties);
}
